import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable()
export class HTTPListener implements HttpInterceptor {
  private onFlyRequestCount = 0;
  private loadingIndicator: HTMLElement = (_ => {
    const loadingIndicator = document.createElement('div');
    loadingIndicator.className = 'loading-container';
    const loadingIcon = document.createElement('i');
    loadingIcon.classList.add('fas', 'fa-spinner', 'fa-spin', 'fa-3x');
    loadingIndicator.appendChild(loadingIcon);
    return loadingIndicator;
  })();

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.appendLoadingIndicator();
    return next.handle(req).pipe(
      map(event => {
        return event;
      }),
      catchError(error => {
        return throwError(error);
      }),
      finalize(() => {
        this.removeLoadingIndicator();
      }),
    );
  }

  appendLoadingIndicator() {
    if (this.onFlyRequestCount === 0) {
      document.body.appendChild(this.loadingIndicator);
    }
    this.onFlyRequestCount++;
  }

  removeLoadingIndicator() {
    this.onFlyRequestCount--;
    if (this.onFlyRequestCount === 0) {
      document.body.removeChild(this.loadingIndicator);
    }
  }
}
